import { AbstractError } from '@/domain/errors/abstract-error.js';

export class NotFoundError extends AbstractError {
    public readonly code = 404;
    constructor(message = 'Not found', args?: string[]) {
        super(message, args);
    }
}
